module.exports = __webpack_public_path__ + "static/media/club-logo.548f69bf.png";